import { createStore, useStore } from './store';

export type Theme = 'dark' | 'light';
const initial = (document.documentElement.dataset.theme as Theme) === 'light' ? 'light' : 'dark';
export const themeStore = createStore<{ theme: Theme }>({ theme: initial });

/** Browser / installed-app chrome colour (status bar, task switcher) matching the page background. */
export function paintChrome(color?: string) {
  const c = color ?? (themeStore.get().theme === 'dark' ? '#0b0c0f' : '#ffffff');
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', c);
}

export function setTheme(t: Theme) {
  document.documentElement.dataset.theme = t;
  try {
    localStorage.setItem('theme', t);
  } catch {
    /* storage unavailable */
  }
  themeStore.set({ theme: t });
  paintChrome();
}
paintChrome();
export const toggleTheme = () => setTheme(themeStore.get().theme === 'dark' ? 'light' : 'dark');
export const useTheme = () => useStore(themeStore, (s) => s.theme);

/** Read a CSS variable (for canvas-based charts that can't use CSS). */
export function cssVar(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
